import type { OfferCatalog, OffersMode } from './offers';
import { LEGACY_OFFER_CATALOG } from './offers-legacy';
import { NEW_OFFER_CATALOG } from './offers-new';

const CATALOGS: Record<OffersMode, OfferCatalog> = {
  legacy: LEGACY_OFFER_CATALOG,
  new: NEW_OFFER_CATALOG,
};

/** The reason table that goes with a mode's data. */
export function offerCatalog(mode: OffersMode): OfferCatalog {
  return CATALOGS[mode];
}
